import styled from 'styled-components';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {Button} from '@yourcoach/shared/uikit/Button';
import {View} from '@yourcoach/shared/uikit/View';

import ModalNew from '@src/components/ModalNew';

export const Modal = styled(ModalNew)`
  border-radius: ${ms(20)}!important;

  .Modal {
    .body {
      padding: ${ms(20)} !important;
    }
  }
`;

export const ButtonsContainer = styled(View)`
  margin-top: ${ms(16)};
  gap: ${ms(12)};
`;

export const FooterButton = styled(Button)`
  flex: 1;
`;
